import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import StatusForm from "./status-form";
import StatusFormResult from "./status-form-result";
import { sampleState } from "../common/defaultState";

export default function StatusDetails(props) {
  const [fstate, setfState] = useState(sampleState);
  const [showSearch, setShowSearch] = useState(true);
  const [searchResult, setSearchResult] = useState({});
  const [srFieldsVALUE, setSrFieldsVALUE] = useState([]);
  const [SRRwoActualStartDate, setSRRwoActualStartDate] = useState(true);
  const [SRRwoActualFinishDate, setSRRwoActualFinishDate] = useState(true);

  useEffect(() => {
    let nValues = {};
    Object.values(props.state).forEach((v) => {
      let o = {
        name: v.name,
        label: v.label,
        required: v.required,
        disable: v.disable,
        errorlabel: v.errorlabel,
        fontWeight: v.fontWeight,
        usepattern: v.usepattern,
        value: "",
        status: -1,
      };
      if (v.name === "SRRwoActualStartDate") setSRRwoActualStartDate(v.disable);
      if (v.name === "SRRwoActualFinishDate")
        setSRRwoActualFinishDate(v.disable);

      nValues[v.name] = o;
    });

    setfState(nValues);
  }, [props.state]);

  const onchange = (e) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setfState({
      ...fstate,
      [e.target.name]: { ...fstate[e.target.name], value },
    });
  };

  const clickNewSearch = (evt) => {
    evt.preventDefault();
    setShowSearch(true);
  };

  const clickSearch = (evt) => {
    evt.preventDefault();
    props.clearAlerts();
    props.loadDiv("show", "In process...");
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        SRnumber: fstate.SRnumber.value,
        SRlastName: fstate.SRlastName.value,
        userSettingsId: props.userSettingsId,
        version: props.version
      })
    };

    window
      .fetch(`CheckStatus`, requestOptions)
      .then((resp) => {
        if (!resp.ok && resp.status == 401) {
          props.loadDiv("hide");
          props.setAlerts(`Unauthorized. Token may have expired.`, "danger");
          throw new Error(`Unauthorized. Token may have expired.`);
        }
        return resp.json();
      })
      .catch((error) => {
        props.loadDiv("hide"); console.log(error);
        throw new Error(error);
      })
      .then((data) => {
        try {
          if (data.status === 0) {
     
            setSrFieldsVALUE(data?.srFieldsVALUE);

            let _searchResult = {};
            _searchResult.comments = data.comments;
            _searchResult.header = [];

            data?.value[0]?.forEach((a) => {
              _searchResult.header.push(
                { label: a.label, disable: false }
              );
            });

            _searchResult.values = data?.value;//wdata;

            _searchResult.SRnumber = {
              name: "SRnumber",
              value: fstate.SRnumber.value,
              label: fstate.SRnumber.label,
              disable: fstate.SRnumber.disable,
            };

            setSearchResult(_searchResult);

            setShowSearch(false);
            props.loadDiv("hide");
          } else {
            props.setAlerts(data.message, "danger");
            props.loadDiv("hide");
          }
        } catch (error) {
          props.loadDiv("hide");
          console.log("Error: ", error);
          props.setAlerts(error, "danger");
        }
      })
      .catch((error) => { console.log(error) });
  };

  return (
    <div className="maxElement">
      <div className="text-right">
        <Button
          color="info"
          onClick={(e) => {
            props.changePage(props.isHome);
          }}
        >
          {props.translate(props.lang, "BackhyperlinkLabel")}
        </Button>
      </div>

      {showSearch && fstate ? (
        <StatusForm
          state={fstate}
          lang={props.lang}
          translate={props.translate}
          onchange={onchange}
          clickSearch={clickSearch}

        />
      ) : (
        ""
      )}

      {!showSearch && fstate ? (
        <StatusFormResult
          state={searchResult}
          lang={props.lang}
          translate={props.translate}
          clickNewSearch={clickNewSearch}
          Guid={props.Guid}
          srFieldsVALUE={srFieldsVALUE}
        />
      ) : (
        ""
      )}
    </div>
  );
}
